import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;
export default {
    getTaxes(params) {
        return Axios.get(`${baseURL}account/search-taxes`, { params }).then(
            res => {
                if (res && res.data && res.data.response) {
                    return res.data.response.resources;
                }
                return null;
            }
        );
    },
    filterLocations(params) {
        return Axios.post(
            `${baseURL}account/options/filter-locations`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    filterCategories(params) {
        return Axios.post(
            `${baseURL}account/options/filter-categories`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    deleteTax(id) {
        return Axios.delete(`${baseURL}account/taxes/${id}`).then(
            response => response
        );
    },
    saveTax(params) {
        return Axios.post(`${baseURL}account/taxes`, params).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    updateTax(id, data) {
        return Axios.put(`${baseURL}account/taxes/${id}`, data).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    }
};
